<div class="placeholder" (click)="close()" class="preview">
  @if (!data.file?.url) {
    <img [src]="data.thumbnail" class="border">
  }
  @if (data.file?.url) {
    <img [src]="data.file?.url" class="border">
  }
</div>